import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 主题色
  colorPrimary: '#1D62E9',
  // layout: 'side',
  layout: 'mix',
  splitMenus: true,
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  // 有我的概览时，添加允许菜单同时展开多个分组
  // siderMenuType: 'group',
  menu: {
    // 默认打开所有的菜单项
    // defaultOpenAll: true,
    // 选中菜单是否自动关闭菜单
    autoClose: false,
  },
  colorWeak: false,
  title: '神石产品控制台',
  pwa: true,
  // logo 在运行时设置（src/app.tsx）
  logo: undefined,
  iconfontUrl: '',
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    // https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F

    // ============ 侧边栏样式配置 ============
    // 侧边栏背景色和菜单样式
    sider: {
      colorMenuBackground: '#ffffff', // 侧边栏背景色（light 主题）
      // colorMenuBackground: '#001529', // 侧边栏背景色（dark 主题）
      colorTextMenu: '#121928', // 菜单文字颜色
      colorTextMenuSelected: '#1D62E9', // 选中菜单文字颜色
      colorTextMenuActive: '#1D62E9', // 激活菜单文字颜色
      colorBgMenuItemSelected: '#EDF4FC', // 选中菜单项背景色
      colorBgMenuItemHover: '#EDF4FC', // 菜单项悬停背景色
    },
    // 页头样式
    header: {
      colorBgHeader: '#1d62e9', // 页头背景色
      colorHeaderTitle: '#FFFFFF', // 页头标题颜色
      heightLayoutHeader: 64, // 页头高度
    },
    // 页面容器样式
    pageContainer: {
      paddingBlockPageContainerContent: 24,
      paddingInlinePageContainerContent: 24,
      colorBgPageContainer: '#F4F7FC', // 页面容器背景色
    },
  },
};

export default Settings;
